// BACK & LAY
export const BACK = 'Back';
export const LAY = 'Lay';

// CALL DECISIONS
export const BET = 'Bet';
export const CALL = 'Call';
export const FOLD = 'Fold';
export const AUTO_FOLD = 'AutoFold';
export const INSURANCE = 'Insurance';
export const SWAP = 'Swap';
export const BUY_PLAYER_CARD = 'BuyPlayerCard';
export const BUY_DEALER_CARD = 'BuyDealerCard';
export const NO_BUY_DEALER_CARD = 'NoBuyDealerCard';
